import { render, staticRenderFns } from "./uploadEnclosure.vue?vue&type=template&id=c6d8cca0"
import script from "./uploadEnclosure.vue?vue&type=script&lang=js"
export * from "./uploadEnclosure.vue?vue&type=script&lang=js"
import style0 from "./uploadEnclosure.vue?vue&type=style&index=0&id=c6d8cca0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports